import React, { ComponentPropsWithRef, forwardRef } from "react";
import Label from "../Label/Label";

import { StyledInput } from "./StyledInput";
import StyledInputHelperText from "./StyledInputHelperText";

interface IProps extends ComponentPropsWithRef<"input"> {
    labelText?: string;
    helperText?: string;
    error?: boolean;
    success?: boolean;
    name: string;
}

const Input = forwardRef<HTMLInputElement, IProps>(function forwardRefCb(props: IProps, ref) {
    const { labelText, name, helperText, error, success, ...rest } = props;
    return (
        <StyledInput hasFieldError={error}>
            {!!labelText && <Label htmlFor={name}>{labelText}</Label>}
            <input ref={ref} id={name} name={name} {...rest} />
            {helperText && (
                <StyledInputHelperText error={error} success={success}>
                    {helperText}
                </StyledInputHelperText>
            )}
        </StyledInput>
    );
});

export default Input;
